module.exports = __webpack_public_path__ + "static/media/Datas_DESENVOLVIMENTO_APLICACOES_MOVEIS.a80e6f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/aplicMoveis/Datas_DESENVOLVIMENTO_APLICACOES_MOVEIS.png
// module id = 58
// module chunks = 0